import React, { useEffect } from "react";
import {
  FaInfoCircle,
  FaUserCheck,
  FaClipboardList,
  FaCreditCard,
  FaUndo,
  FaBan,
  FaShieldAlt,
  FaBalanceScale,
  FaDatabase,
  FaCopyright,
  FaUserSlash,
  FaGlobe,
  FaPhoneAlt,
} from "react-icons/fa";

/* CARD */
const Card = ({ title, desc, icon }) => (
  <div
    className="
      group
      bg-white/90 backdrop-blur-sm
      border border-red-100
      rounded-2xl
      p-4 md:p-5
      shadow-sm
      hover:shadow-xl
      hover:-translate-y-1
      transition-all duration-300
    "
  >
    {/* ICON */}
    <div
      className="
        w-12 h-12
        rounded-2xl
        bg-gradient-to-br from-red-50 to-red-100
        text-red-600
        flex items-center justify-center
        mb-4
        group-hover:from-red-500
        group-hover:to-red-600
        group-hover:text-white
        transition-all duration-300
      "
    >
      {icon}
    </div>

    {/* TITLE */}
    <h2 className="text-base md:text-lg font-semibold text-gray-800 mb-2">
      {title}
    </h2>

    {/* DESC */}
    <p className="text-gray-500 leading-relaxed text-sm">
      {desc}
    </p>
  </div>
);

export default function TermsConditions() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const terms = [
    {
      icon: <FaInfoCircle size={20} />,
      title: "Introduction",
      desc: "These Terms govern your use of MedrphaLab platform and services.",
    },
    {
      icon: <FaClipboardList size={20} />,
      title: "Nature of Services",
      desc: "We provide lab discovery, booking and payment facilitation only.",
    },
    {
      icon: <FaUserCheck size={20} />,
      title: "Eligibility",
      desc: "User must be 18+ and legally capable of using our platform.",
    },
    {
      icon: <FaUserSlash size={20} />,
      title: "User Account",
      desc: "You are responsible for maintaining account security.",
    },
    {
      icon: <FaCreditCard size={20} />,
      title: "Bookings & Payments",
      desc: "All bookings depend on availability and secure payment processing.",
    },
    {
      icon: <FaUndo size={20} />,
      title: "Cancellation & Refund",
      desc: "Refunds depend on lab policy and take 5–10 working days.",
    },
    {
      icon: <FaBan size={20} />,
      title: "User Conduct",
      desc: "No misuse, false information or illegal activity allowed.",
    },
    {
      icon: <FaGlobe size={20} />,
      title: "Third-Party Services",
      desc: "We are not responsible for third-party lab services.",
    },
    {
      icon: <FaShieldAlt size={20} />,
      title: "Disclaimer",
      desc: "Service is provided on an 'as-is' basis without guarantees.",
    },
    {
      icon: <FaBalanceScale size={20} />,
      title: "Limitation of Liability",
      desc: "We are not liable for indirect or incidental damages.",
    },
    {
      icon: <FaDatabase size={20} />,
      title: "Data Protection",
      desc: "Your data is protected as per our privacy policy.",
    },
    {
      icon: <FaCopyright size={20} />,
      title: "Intellectual Property",
      desc: "All content belongs to MedrphaLab platform.",
    },
    {
      icon: <FaUserSlash size={20} />,
      title: "Termination",
      desc: "We may suspend access at any time without notice.",
    },
    {
      icon: <FaBalanceScale size={20} />,
      title: "Governing Law",
      desc: "Governed by Indian law. Jurisdiction: Noida.",
    },
    {
      icon: <FaPhoneAlt size={20} />,
      title: "Contact Information",
      desc: "Email: info@medrpha.com | Noida, India",
    },
  ];

  return (
    <div className="w-full min-h-screen pt-28 bg-gradient-to-br from-gray-50 via-white to-red-50">

      {/* HERO */}
      <div
        className="
          w-full
          bg-gradient-to-r from-red-600 to-red-500
          text-white
          py-10 md:py-12
          px-4 md:px-10
          text-center
        "
      >
        <h1 className="text-2xl md:text-4xl font-bold mb-2">
          Terms & Conditions
        </h1>

        <p className="max-w-2xl mx-auto text-xs md:text-base opacity-90 leading-relaxed">
          MedrphaLab (Medrpha Technologies Private Limited) <br />
          Effective Date: 01 Jan 2026
        </p>
      </div>

      {/* CONTENT */}
      <div className="px-4 md:px-10 py-6 md:py-8">

        <div className="grid gap-4 md:gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {terms.map((item, index) => (
            <Card
              key={index}
              icon={item.icon}
              title={item.title}
              desc={item.desc}
            />
          ))}
        </div>

      </div>
    </div>
  );
}